export type Config = {
	appName: string;
	apiUrl: string;
};

export const config: Config = {
	appName: process.env.REACT_APP_APP_NAME ?? '',
	apiUrl: process.env.REACT_APP_API_URL ?? '',
};
